import '../styles/_styles.scss';
import './scroll';
import './hamburger';
import './photoswipe';
import './vipps';
import './inner-height';

import './angular/polyfill';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './angular/app.module';

enableProdMode();
platformBrowserDynamic().bootstrapModule(AppModule);